import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToastService } from '../../services/toast.service';
import { MatIcon } from '@angular/material/icon';
import { ResponsiveService } from '../../services/responsive.service';

@Component({
  selector: 'app-toast',
  imports: [CommonModule, MatIcon],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() notificationInfo: any;
  @Output() selectedChanged = new EventEmitter<boolean>();
  selected = false;

  private readonly responsive = inject(ResponsiveService);
  readonly isTablet = toSignal(this.responsive.isTablet$, { initialValue: false });

  readonly positionTop = computed(() => {
    const hasPriceCard = this.toastService.toasts().some((toast) => toast.priceCard);
    if (this.isTablet()) return '60px';
    if (hasPriceCard) return '310px';
    return '80px';
  });

  constructor(public toastService: ToastService) {}

  remove(index: number) {
    this.toastService.remove(index);
  }

  selectNotification() {
    this.selectedChanged.emit(!this.selected);
  }
}
